export enum CookieName {
  FONT = "font",
  THEME = "theme",
  SEEN_MONETIZATION_THANK_YOU = "seen_wm_thanks_msg",
  IS_SUPPORTER = "is_supporter",
}
